"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var styled_1 = require("../styled");

var WithBoolFilters =
/** @class */
function (_super) {
  __extends(WithBoolFilters, _super);

  function WithBoolFilters() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      activeFilter: '',
      filteredData: []
    };

    _this.filterPressHandler = function (filter) {
      return function () {
        var name = filter.name;
        var activeFilter = _this.state.activeFilter; // if deselecting the filter, set the default value

        var isDeselecting = activeFilter === name;
        var newActiveFilter = isDeselecting ? '' : name;
        var filteredData = isDeselecting ? [] : _this.filterData(filter);

        _this.setState({
          filteredData: filteredData,
          activeFilter: newActiveFilter
        });
      };
    };

    _this.filterData = function (_a) {
      var filterProp = _a.filterProp,
          value = _a.value;
      var data = _this.props.data;
      return data.filter(function (item) {
        return item[filterProp] === value;
      });
    };

    _this.renderFilters = function () {
      var filters = _this.props.filters;
      return filters.map(function (filter, idx) {
        return react_1.default.createElement(FilterItem, {
          key: idx,
          onPress: _this.filterPressHandler(filter),
          isActive: _this.isFilterActive(filter.name)
        }, react_1.default.createElement(react_native_1.Text, null, filter.name));
      });
    };

    _this.isFilterActive = function (filterName) {
      return filterName === _this.state.activeFilter;
    };

    return _this;
  }

  WithBoolFilters.prototype.render = function () {
    var _a = this.state,
        filteredData = _a.filteredData,
        activeFilter = _a.activeFilter;
    var _b = this.props,
        renderFiltered = _b.renderFiltered,
        data = _b.data,
        displayFilters = _b.displayFilters;
    var filtered = !activeFilter ? data : filteredData;
    return react_1.default.createElement(Container, null, displayFilters && react_1.default.createElement(FiltersRowContainer, null, this.renderFilters()), react_1.default.createElement(ItemsContainer, null, renderFiltered(filtered)));
  };

  return WithBoolFilters;
}(react_1.Component);

exports.WithBoolFilters = WithBoolFilters;
var Container = styled_components_1.default(styled_1.ColumnFlexStartResponsive)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 12px;\n    min-width: 320px;\n    max-width: 560px;\n"], ["\n    margin-top: 12px;\n    min-width: 320px;\n    max-width: 560px;\n"])));
var ItemsContainer = styled_components_1.default(styled_1.ColumnFlexStartResponsive)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-width: 320px;\n    max-width: 560px;\n"], ["\n    min-width: 320px;\n    max-width: 560px;\n"])));
var FiltersRowContainer = styled_components_1.default(styled_1.RowFlexStart)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: 24px;\n"], ["\n    margin-bottom: 24px;\n"])));
var FilterItem = styled_components_1.default(function (_a) {
  var isActive = _a.isActive,
      theme = _a.theme,
      rest = __rest(_a, ["isActive", "theme"]);

  return react_1.default.createElement(react_native_1.TouchableWithoutFeedback, __assign({}, rest));
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: 20px;\n    ", ";\n"], ["\n    margin-right: 20px;\n    ", ";\n"])), function (_a) {
  var isActive = _a.isActive,
      theme = _a.theme;
  return "\n            color: " + (isActive ? theme.colors.secondary.orange : theme.colors.label) + "\n            font-weight: " + (isActive ? 'bold' : 'normal') + ";\n        ";
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;